import React from 'react';
import { ShieldAlert, Baby, PiggyBank, TrendingUp } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const painPoints = [{
  icon: <ShieldAlert className="w-8 h-8 text-vitality-green" data-id="element-88" />,
  text: 'Si hoy estás desprotegido y no tienes un seguro contra enfermedades graves o accidentes, esto es para ti.'
}, {
  icon: <Baby className="w-8 h-8 text-vitality-green" data-id="element-89" />,
  text: 'Si tienes hijos pequeños y te preocupa que el día de mañana puedan quedar desamparados, esto es para ti.'
}, {
  icon: <PiggyBank className="w-8 h-8 text-vitality-green" data-id="element-90" />,
  text: 'Si aún no tienes un plan de ahorro para tu futuro y no quieres depender del Estado, esto es para ti.'
}, {
  icon: <TrendingUp className="w-8 h-8 text-vitality-green" data-id="element-91" />,
  text: 'Si buscas crecimiento constante en tus ahorros, sin riesgo de pérdida, esto es para ti.'
}];
export function PainPoints() {
  return <section className="bg-light-gray py-24" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-93">
        <FadeInUp data-id="element-94">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-95">
            <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-96">
              ¿Te identificas con alguna de estas situaciones?
            </h2>
            <div className="w-24 h-1 bg-vitality-green mx-auto rounded-full" data-id="element-97"></div>
          </div>
        </FadeInUp>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-98">
          {painPoints.map((point, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-99">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex gap-6 items-start h-full hover:shadow-md transition-shadow" data-id="element-100">
                <div className="flex-shrink-0 bg-light-gray p-4 rounded-full" data-id="element-101">
                  {point.icon}
                </div>
                <p className="text-gray-700 text-lg leading-relaxed pt-1" data-id="element-102">
                  {point.text}
                </p>
              </div>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}